<template>
  <div
    class="bc-report-type-container"
    :class="{ 'has-header': hasHeader }"
  >
    <div
      v-if="hasHeader"
      class="header"
    >
      <span>{{ title }}</span>
      <slot name="header" />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ReportTypeContainer',
  props: {
    hasHeader: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'phone'
    },
    title: {
      type: String,
      default: '整体风险说明'
    }
  }
}
</script>

<style lang="stylus">
.bc-report-type-container
  padding-top 1px
  &.has-header
    padding-top 20px
  .header
    border-bottom 1px solid $color-border
    font-size 16px
    font-weight 500
    display flex
    align-items center
    padding 14px 10px
    position relative
    margin-bottom 20px
    .one
      display flex
      margin-right 10px
</style>
